import React from 'react';
import { Box } from '@mui/system';

const CheckIcon = () => {
  return (
    <Box
      sx={{
        width: '20px',
        height: '20px',
        bgcolor: 'background.default',
        borderRadius: '10px',
        border: '1px solid',
        borderColor: 'secondary.dark',
      }}
    />
  );
};

export default CheckIcon;
